type CedeIconProps = {
  width?: number;
  height?: number;
};
export const CedeIcon = ({ width = 22, height = 22 }: CedeIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.501492 5.27982C0.501492 2.363 2.86583 0 5.78096 0H17.2205C20.1371 0 22.5 2.36449 22.5 5.27982V16.7202C22.5 19.637 20.1357 22 17.2205 22H5.75409C2.8524 22 0.5 19.6474 0.5 16.7456V5.27833L0.501492 5.27982Z"
      fill="#5EA6FF"
    />
    <path
      d="M1.77103 5.93641C1.77103 3.35696 3.86221 1.26562 6.44149 1.26562H16.5616C19.1409 1.26562 21.232 3.35696 21.232 5.93641V16.0572C21.232 18.6366 19.1409 20.728 16.5616 20.728H6.41761C3.85027 20.728 1.76953 18.6471 1.76953 16.0796V5.93492L1.77103 5.93641Z"
      fill="black"
    />
    <path
      d="M3.04102 6.60081C3.04102 4.35722 4.85905 2.53906 7.10248 2.53906H15.9031C18.1465 2.53906 19.9645 4.35722 19.9645 6.60081V15.402C19.9645 17.6456 18.1465 19.4638 15.9031 19.4638H7.08308C4.85159 19.4638 3.04251 17.6546 3.04251 15.4214V6.60081H3.04102Z"
      fill="white"
    />
    <path
      d="M9.64719 11.8467C10.4757 10.4117 10.2387 8.72367 9.11781 8.0765C7.99696 7.42933 6.41672 8.06806 5.58824 9.50313C4.75975 10.9382 4.99676 12.6262 6.11761 13.2734C7.23846 13.9205 8.81871 13.2818 9.64719 11.8467Z"
      fill="black"
    />
    <path
      d="M8.7591 10.5457C9.2463 10.5457 9.64125 10.1507 9.64125 9.66346C9.64125 9.17622 9.2463 8.78125 8.7591 8.78125C8.2719 8.78125 7.87695 9.17622 7.87695 9.66346C7.87695 10.1507 8.2719 10.5457 8.7591 10.5457Z"
      fill="white"
    />
    <path
      d="M16.9301 13.2829C18.0509 12.6357 18.2879 10.9477 17.4595 9.51264C16.631 8.07756 15.0507 7.43884 13.9299 8.08601C12.809 8.73318 12.572 10.4212 13.4005 11.8562C14.229 13.2913 15.8092 13.93 16.9301 13.2829Z"
      fill="black"
    />
    <path
      d="M14.2904 10.5613C14.7776 10.5613 15.1725 10.1663 15.1725 9.67909C15.1725 9.19186 14.7776 8.79688 14.2904 8.79688C13.8032 8.79688 13.4082 9.19186 13.4082 9.67909C13.4082 10.1663 13.8032 10.5613 14.2904 10.5613Z"
      fill="white"
    />
    <path
      d="M11.5248 14.2905C11.5248 14.2905 10.8949 14.2651 10.6695 14.4264C10.4441 14.5876 10.459 14.8369 10.459 14.8369C10.459 14.8369 10.4292 15.0921 10.5038 15.2578C10.5784 15.4235 11.0158 15.3951 11.2307 15.7639C11.2307 15.7639 11.4277 15.831 11.5248 15.8116"
      fill="black"
    />
    <path
      d="M11.5254 14.2905C11.5254 14.2905 12.1553 14.2651 12.3807 14.4264C12.6061 14.5876 12.5911 14.8369 12.5911 14.8369C12.5911 14.8369 12.621 15.0921 12.5464 15.2578C12.4717 15.4235 12.0344 15.3951 11.8194 15.7639C11.8194 15.7639 11.6224 15.831 11.5254 15.8116"
      fill="black"
    />
  </svg>
);
